import gql from 'graphql-tag'

const updateBookingInvites = gql`
  mutation updateBookingInvites($bookingNumber: String!, $leadPassengerName: String!, $signInUrl: String!, $signUpUrl: String!, $invites: [BookingInviteInput]!) {
    updateBookingInvites(bookingNumber: $bookingNumber, leadPassengerName: $leadPassengerName, signInUrl: $signInUrl, signUpUrl: $signUpUrl, invites: $invites)
  }
`

const revokeBookingInvite = gql`
  mutation revokeBookingInvite($bookingNumber: String!, $passengerIndex: Int!) {
    revokeBookingInvite(bookingNumber: $bookingNumber, passengerIndex: $passengerIndex)
  }
`

const removeBooking = gql`
  mutation removeBooking($bookingNumber: String!) {
    removeBooking(bookingNumber: $bookingNumber)
  }
`

const cancelBooking = gql`
  mutation cancelBooking($bookingNumber: String!, $sourceSystem: String!) {
    cancelBooking(bookingNumber: $bookingNumber, sourceSystem: $sourceSystem)
  }
`

const addBooking = gql`
  mutation addBooking($bookingNumber: String!) {
    addBooking(bookingNumber: $bookingNumber)
  }
`

const addSelfServiceCase = gql`
  mutation addSelfServiceCase($data: SelfServiceCaseInput!) {
    addSelfServiceCase(data: $data)
  }
`

const sendGuideOnlineMessage = gql`
  mutation sendGuideOnlineMessage($bookingNumber: String!, $text: String!) {
    sendGuideOnlineMessage(bookingNumber: $bookingNumber, text: $text) {
      fromTui
      text
      timestamp
    }
  }
`
const getPaymentUrl = gql`
  mutation getPaymentUrl($bookingNumber: String!, $sourceSystem: String!) {
    paymentUrl(bookingNumber: $bookingNumber, sourceSystem: $sourceSystem) {
      url
    }
  }
`

export { updateBookingInvites, revokeBookingInvite, removeBooking, addBooking, addSelfServiceCase, cancelBooking, sendGuideOnlineMessage, getPaymentUrl }
